define('fusion/ui/controls/fusion-mfa-verify',[
    "fusion/fusion.control"
], function (ControlFactory) {
    return ControlFactory.control(function ($, ko, $log, $utility) {
        var c = this;

        c.settingsDefinition = {
            value: { isLive: true, defaultValue: '' },
            numberOfCodeDigits: { isLive: false, defaultValue: 6 },
            isValueReady: { isLive: true, defaultValue: false },
            /*isAlphaNumericOnly: { isLive: false, defaultValue: true }, */
            clearCode: { isLive: true, defaultValue: false }
        };


        c.validateValues = function (settings) {
            // checking for direct content
            if (settings.__hasDirectContent) {
                var msg = "fusion-mfa-code does not support direct content";
                $log.warning(msg);
            }

        }

        c.beforeBind = function ($markup, settings, bindingContext, $element) {

            // ensuring number of digits is a number
            var x = parseInt(settings.numberOfCodeDigits);
            if (isNaN(x)) {
                throw new Error("The number of digits must be an integer");
            }
            else {
                settings.numberOfCodeDigits = x;
            }
         

            // digit array defined and allocated - note subscribing to this array was problematic
            settings.dArray = ko.observableArray(Array.from({ length: settings.numberOfCodeDigits }));

            // setting some initialization flags
            settings.isDigitArrayInit = ko.observable(false);
            settings.isDigitArrayDirty = ko.observable(false);
            settings.tempValidtionError = ko.observable(false);


            // clearCode subscribes to VM flag to reset the control
            settings.clearCode.subscribe(function (val) {
                if (val) {
                    // getting  inputs and clearing by clicking on first input element
                    var inputs = $markup.find('.input-pin');
                    $(inputs[0]).click().mousedown().mouseup();

                    // resetting the clearCode observable 
                    settings.clearCode(false);
                }
            });


            // setting up internal validation

            // returns false is a non digit is found
            var isAllDigits = function(val) {
                var returnVal;

                if (val) {
                    var testVal = Array.from(val.toString(), Number);
                    //returnVal = !(testVal.some(i => !Number.isInteger(i)));
                    returnVal = !(testVal.some(function (i) {
                        return !Number.isInteger(i)
                    }));
                }
                return returnVal;
            }

            var doesLengthMatch = function(val) {
                var returnVal;
                if (val) {
                    var testVal = Array.from(val.toString(), Number);
                    returnVal = (testVal.length === settings.numberOfCodeDigits);
                }

                return returnVal;
            };


            function clearCodeAndDigits() {

                // flag to indicate validation error encountered - need a separate one from settings.value.isValid() for this 
                settings.tempValidtionError(true);

                // clearing val to the view model
                //settings.value('');

                // getting array of markup digits
                var arrayOfDigits = $markup.find("input");

                // marking the digits array as not dirty since we are clearing things
                settings.isDigitArrayDirty(false);

                // clear each digit in dArray
                for (var i = 0; i < settings.numberOfCodeDigits; i++) {
                    settings.dArray()[i] = '';

                    $(arrayOfDigits[i]).val('');
                    $(arrayOfDigits[i]).attr('disabled', true);
                }

                // setting focus to the first field a
                var $first = $($markup.find('.input-pin')[0]);
                $first.removeAttr('disabled').focus();
            }



            //settings.value.extend({
            //    validation: {
            //        validator: isAllDigits,
            //        message: function () {
            //            if (settings.isDigitArrayDirty() && settings.value()) {
            //                var msg = 'Invalid code - can only be numerical digits.  Val : ' + ko.utils.unwrapObservable(settings.value);
            //                $log.debug(msg);
            //                clearCodeAndDigits();
            //                return msg;
            //            }
            //        },
            //        params: settings.value
            //    }
            //})
            //    .extend({
            //        validation: {
            //            validator: doesLengthMatch,
            //            message: function () {
            //                if (settings.isDigitArrayDirty() && settings.value()) {
            //                    var msg = 'Invalid code - code length does not match number of digits.  Val : ' + ko.utils.unwrapObservable(settings.value);
            //                    $log.debug(msg);
            //                    clearCodeAndDigits();
            //                    return msg;
            //                }
            //            },
            //            params: settings.value
            //        }
            //    });
        }

        c.afterBind = function ($markup, settings, bindingContext, $element) {
        }


        c.afterDomInsert = function ($markup, settings, bindingContext) {

            // remove disabled attr on first input
            $first = $($markup.find('.input-pin')[0]);
            $first.removeAttr('disabled').focus();          // removing disabled attr on first input and setting focus there

            // setting up event handlers
            var $inputs = $($markup.find('.input-pin'));

            // setting up control event hanlders
            _associateEvents();

            // setting initial control focus to the first field, ready to type
            $inputs.first().removeAttr('disabled').focus();



            //#region helper functions

            // helper to set up various eventhandlers for the control
            function _associateEvents() {

                for (var i = 0; i < settings.numberOfCodeDigits; i++) {
                    $($inputs[i]).on('keyup', _handleChange);
                    //$($inputs[i]).on('change', _handleChange);
                    $($inputs[i]).on('mouseup', _clearToEnd);
                    $($inputs[i]).on('paste', _handlePaste);
                }
            }

            function _moveNext($t) {
                var $next = $t.next('input');

                if ($next) {
                    if (Number.isInteger(parseInt($next.val()))) {   // if a number is in the next input, then skip to the following one
                        _moveNext($next);
                    }
                    else {
                        $next.prop('disabled', false).focus();
                    }
                }
            }

            function _movePrev($t) {
                // disable the current input
                $t.prop('disabled', true).val('');        // disabling and clearing

                //focus on the previous input
                $t.prev('input').focus().val('');
            };

            function _resetDigitsToEnd(startPosition, $current) {
                for (var i = startPosition; i < settings.numberOfCodeDigits; i++) {
                    settings.dArray()[i] = undefined;       // clearing array position
                    $current.val('');                       // clearing input
                    $current = $current.next('input');      // moving to the next position
                    $current.attr('disabled', 'true');      // setting disabled 
                }
                $log.trace("Array reset from position " + startPosition + " is complete");

                settings.value.isModified(false);       // clearing any existing errors on the field if user clicks into a digit
            };

            function _clearToEnd(e) {
                if (settings.isDigitArrayDirty()) {        // eliminates initial click into first field
                    var position = e.target.getAttribute("tabindex");
                    _resetDigitsToEnd(position, $(this));
                }
                else {
                    settings.isDigitArrayDirty(!isNaN(settings.dArray()));  // after first click array should be considered edited as long as there are digits
                }
            }

            // since subscription to the obs array was not behaving as expected, doing this in a more manual way
            function _checkArrayReady() {
                var isReady = true;

                // looping through digits and using bit logic to determine if array is ready
                for (var i = 0; i < settings.dArray().length; i++) {
                    //isReady = isReady && !isNaN(settings.dArray()[i]);
                    //isReady = isReady && !isNaN(settings.dArray()[i]) && (settings.dArray()[i] !== '' && settings.dArray()[i] !== null && settings.dArray()[i] !== undefined);
                    isReady = isReady &&  (settings.dArray()[i] !== '' && settings.dArray()[i] !== null && settings.dArray()[i] !== undefined);
                }

                return isReady;
            }

            function _updateArray(position, value) {
                settings.dArray()[position] = value;

                $log.trace("in UpdateArray, Array changed : " + settings.dArray().join(''));

                if (_checkArrayReady()) {
                    $log.trace("fusion-mfa :: digits are complete : " + settings.dArray().join(''));

                    // emitting when all digits are ready
                    settings.value(settings.dArray().join(''));
                    settings.isValueReady(true);
                }
            }


            function _performCharCheck(key, $current) {

                var rtnVal = true;

                //// perform initial check for non-numberic chars un less it is a backspace or one of the control chars, i.e. CTRL
                //if (key !== 8 && key !== 46 && !(key >= 17 && key <= 20)) {

                //    var reg = new RegExp('^[0-9]$');
                //    var result = reg.test($current.val());

                //    if (!result) {                // indicates a non-numeric val entered and needs to be handled
                //        //strip the current char out
                //        $current.val(null);

                //        // log a warning
                //        $log.debug("Non-numberic entries are not accepted - key val entered : " + key + ", " + String.fromCharCode((96 <= key && key <= 105) ? key - 48 : key));

                //        rtnVal = false;
                //    }
                //}

                return rtnVal;
            }

            function _isPasteEvent(e) {
                var returnVal = false;

                if (e.originalEvent) {

                    // look for CTRL + V
                    // KeyboardEvent { isTrusted: true, key: 'v', code: 'KeyV', location: 0, ctrlKey: true, … }
                    // look for CTRL key only
                    //KeyboardEvent { isTrusted: true, key: 'Control', code: 'ControlLeft', location: 1, ctrlKey: false, … }

                    returnVal = (e.originalEvent.ctrlKey && e.originalEvent.code === 'KeyV') ||
                        (e.originalEvent.type === 'keyup' && (e.originalEvent.code === 'ControlLeft' || e.originalEvent.code === 'ControlRight'));

                }

                return returnVal;

            }



            //#endregion helper functions


            //#region  main change handler methods
            function _handlePaste(e) {

                $log.trace("Handling paste event");

                // stopping propagation so control can handle everything
                //e.preventDefault();
                //e.stopPropagation();

                var paste = (e.clipboardData || window.clipboardData || e.originalEvent.clipboardData).getData("text");
                //var digitArray = Array.from(paste, Number)
                var digitArray = Array.from(paste);

                // ensuring the copied array does not exceed # of digits - otherwise the extra digits will be added even though this is an error condition
                var resultArray = (digitArray.length <= settings.numberOfCodeDigits) ? digitArray : digitArray.slice(0, settings.numberOfCodeDigits);

                // update the control value
                //settings.dArray(resultArray);


                // cldearing temp validation flag
                settings.tempValidtionError(false);

                // setting indicator that array is dirty since we are pasting rather than typing
                settings.isDigitArrayDirty(true);


                // getting array of markup digits
                var arrayOfDigits = $markup.find("input");

                // processing each digit
                for (var i = 0; i < settings.numberOfCodeDigits; i++) {
                    if (i < settings.numberOfCodeDigits) {

                        _updateArray(i, digitArray[i]);

                        $(arrayOfDigits[i]).val(digitArray[i]);
                        $(arrayOfDigits[i]).attr('disabled', false);
                    }
                }

                // Setting the control value - needs to be last to account for changes/clearing that happens with validation
                settings.value(paste);

            }


            function _handleChange(e) {

                // skipping this logic if the event is a paste event
                if (!_isPasteEvent(e)) {

                    $log.trace("Handling change event");

                    var key = e.keyCode || e.charCode;

                    var $prev = $(this).prev('input');
                    var $current = $(this);


                    // resetting control value once we have a key press - indicates the user is entering new data if there was an error
                    if (settings.value()) {
                        settings.value('');   
                    }


                    // check for non numeric chars
                    if (_performCharCheck(key, $current)) {
                        // if this is a backspace
                        if (key === 8 || key === 46) {
                            if (parseInt($current.attr("tabindex")) === settings.numberOfCodeDigits - 1) {   // at the last digit
                                settings.value.isModified(false);       // clearing any existing errors on the field if user clicks into a digit
                                _updateArray(parseInt($current.attr("tabindex")), undefined);       // clearing end digit
                                _movePrev($current);

                                _updateArray(parseInt($current.attr("tabindex")) - 1, undefined);   // clearing previous digit like normal
                                _movePrev($current);

                            }
                            else if (parseInt($current.attr("tabindex")) !== 0) {         // making sure we are not at the first spot
                                _updateArray(parseInt($current.attr("tabindex")) - 1, undefined);
                                _movePrev($current);
                            }
                        }
                        // otherwise  assume a proper number input
                        else {
                            if (key) {  // acts a debounce to prevent mult passes through this logic
                                if (!settings.isDigitArrayDirty()) {
                                    settings.isDigitArrayDirty(true);
                                }
                                //_updateArray(parseInt($current.attr("tabindex")), parseInt($current.val()));
                                _updateArray(parseInt($current.attr("tabindex")), $current.val());

                                _moveNext($current);
                            }
                        }
                    }
                }
            };

            //#endregion  main change handler methods


            // set the initialized flag
            settings.isDigitArrayInit(true);

        }
    });
});
